export default {
  sm: 360,
  md: 564,
  lg: 768,
  xl: 1024,
  max: 1280
};
//# sourceMappingURL=breakpoints.js.map